export default __webpack_public_path__ + "static/wazoku-one-big-thing-h-2e1ce709c2c26a3974e5a147cda7c9fb.png";